<!-- LOADING AREA START ===== -->
<div appLoader class="loading-area">
    <div class="loading-box"></div>
    <div class="loading-pic">
      <img src="assets/images/Rolling-1s-220px.svg" alt="loading....">
    </div>
</div>
<!-- LOADING AREA  END ====== -->
